import { createStore } from "vuex";
import permissions from "./modules/permissions";

export default createStore({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        permissions,
    },
});
